var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.366 10.0003C10.636 10.1243 8.95 10.5083 7.758 11.7023C6 13.4623 6 16.2963 6 21.9623V31.9803C6 37.6463 6 40.4803 7.758 42.2403C9.514 44.0003 12.344 44.0003 18 44.0003H30C35.656 44.0003 38.486 44.0003 40.242 42.2403C41.998 40.4803 42 37.6463 42 31.9803V21.9603C42 16.2943 42 13.4603 40.242 11.7003C39.05 10.5063 37.362 10.1203 34.634 9.99829",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0494 13.0805C13.0894 9.32049 12.6094 7.44049 13.3894 6.06049C13.5984 5.6929 13.8644 5.36078 14.1774 5.07649C15.3554 4.00049 17.3374 4.00049 21.2994 4.00049H26.6994C30.6614 4.00049 32.6434 4.00049 33.8214 5.07649C34.1354 5.36249 34.4014 5.69649 34.6094 6.06249C35.3894 7.44249 34.9094 9.32249 33.9494 13.0825C33.1814 16.0785 32.7994 17.5765 31.7754 18.5625C31.4954 18.8332 31.1881 19.0685 30.8534 19.2685C29.6254 20.0005 28.0454 20.0005 24.8874 20.0005H23.1114C19.9514 20.0005 18.3714 20.0005 17.1454 19.2685C16.8135 19.0688 16.5049 18.8327 16.2254 18.5645C15.1994 17.5765 14.8154 16.0785 14.0494 13.0805Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.0002H28M23 20.0002L25 14.0002",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.65070d7a3c2d59918a64cccfe8636ce4.svg";
export { ForwardRef as ReactComponent };